export const SITE_TITLE = "astra";
export const SITE_DESCRIPTION =
  "Astra is a platform for creating and managing AI agents.";

export const WIDGET_NAME = "astra-widget";

export const TOKEN_NAME = "Token";
export const AUTH_KEY = "X-Astra-Token";

export const DEFAULT_COLOR_THEME = "#007af5";

export enum HeightMode {
  OnlyChat = "OnlyChat", // no welcome message and no conversation starter
  WelcomeChat = "WelcomeChat", // only welcome message
  StartChat = "StartChat", // only conversation starter
  FullChat = "FullChat", // has welcome message and conversation starter
  CallChat = "CallChat", // only has call form
  OnChat = "OnChat"
}

export enum HeightModeVal {
  OnlyChat = 60,
  CallChat = 366,
  OnChat = 720
}

export const TEMPLATE_ID = "550e8400-e29b-41d4-a716-446655441112";

export const PROD_HOSTS = ["app.engagechat.ai", "astra.wati.io"];

// Environment host configurations
export const QA_HOSTS = ["qa-astra.engagechat.ai", "qa-astra.watiapp.io"];
export const DEV_HOSTS = ["dev-astra.engagechat.ai", "dev-astra.watiapp.io"];
export const DEV_BETA_HOSTS = [
  "dev-beta-astra.engagechat.ai",
  "dev-beta-astra.watiapp.io"
];

/**
 * Determine the current environment based on hostname
 * @param hostname Current hostname
 * @returns Environment name
 */
export function getEnvironmentByHostname(hostname: string): string {
  if (PROD_HOSTS.includes(hostname)) {
    return "production";
  }
  if (QA_HOSTS.includes(hostname)) {
    return "qa";
  }
  if (DEV_BETA_HOSTS.includes(hostname)) {
    return "dev-beta";
  }
  if (DEV_HOSTS.includes(hostname)) {
    return "development";
  }
  // Local development environment (localhost, 127.0.0.1, etc.)
  if (
    hostname.includes("localhost") ||
    hostname.includes("127.0.0.1") ||
    hostname.includes("0.0.0.0")
  ) {
    return "local";
  }
  // Default to development environment
  return "development";
}

/**
 * Determine whether Sentry error monitoring should be enabled
 * @param hostname Current hostname
 * @returns Whether to enable Sentry
 */
export function shouldEnableSentry(hostname: string): boolean {
  const env = getEnvironmentByHostname(hostname);
  // Only enable Sentry in production and QA environments
  return env === "production" || env === "qa";
}

export const STATSIG_CLIENT_KEY =
  "client-OJkxXOHpS020zcCvboypoiGeHISOKzajN7gZQyyyxuP";

export const AgentMapping = {
  "24a61855-029b-4316-9948-467686f47a7b": {
    support: "60f82873-163b-4210-a30f-3c1a0b1711d8",
    marketing: "9980286f-7495-4ea9-bf54-06c50b3487f1",
    sales: "b9193437-4c9f-4d0d-b16c-36ae700eaddc"
  },
  "3fe52677-ed18-480f-a342-b55851bec43d": {
    marketing: "17cdf73e-631b-4240-aba9-77eac13083ce",
    support: "d1065f2b-878b-432e-bbe0-649d1a240f7b",
    sales: "1ccd20ee-896f-4938-8481-7bb10bc2338f"
  }
};